import Color from "color";
import { addStyleElement } from "./dom";

const colorBrand = "#a49533";

const _colorBrand = Color(colorBrand); // goldish brand core
const _colorAccent = Color("#384347"); // cool slate accent
const colorBg = "#272727"; // dark base background

const colors = {
  brand_main: _colorBrand.hex(), // primary brand color
  brand_light: _colorBrand.lighten(0.15).saturate(0.1).hex(), // hover / highlight
  brand_dark: _colorBrand.darken(0.3).desaturate(0.1).hex(), // pressed / outline
  brand_muted: _colorBrand.mix(Color(colorBg), 0.5).hex(), // subtle background tint
  brand_line: _colorBrand.alpha(0.35).string(), // translucent divider / line
  brand_glow: _colorBrand.mix(Color("white"), 0.25).alpha(0.5).string(), // focus / glow

  accent_main: _colorAccent.hex(), // secondary / cool grounding tone
  accent_light: _colorAccent.lighten(0.3).hex(), // link hover / accent hover
  accent_dark: _colorAccent.darken(0.2).hex(), // pressed / outline

  bg_base: colorBg, // app background
  bg_elevated: "#313131", // cards, modals, raised surfaces
  bg_muted: "#515151", // secondary panels
  bg_darker: Color(colorBg).darken(0.3).hex(), // deep header/footer

  text_primary: "#e8e8e8", // default readable text
  text_secondary: "#bcbcbc", // muted / placeholder text
  // text_inverse: "#111111", // text on light backgrounds
  // text_highlight: "#f5f5f5", // for bright highlights

  // line_subtle: _colorBrand.alpha(0.35).string(), // faint divider lines
  // line_strong: "#3c3c3c", // more visible divider

  // button_fill: _colorBrand.hex(), // primary button
  // button_hover: _colorBrand.lighten(0.15).saturate(0.1).hex(), // hover
  // button_pressed: _colorBrand.darken(0.3).desaturate(0.1).hex(), // pressed
  // button_outline: _colorBrand.darken(0.3).desaturate(0.1).hex(), // border/outline

  // input_background: "#313131", // field background
  // input_border: "#515151", // field border
  // input_focus: _colorBrand.mix(Color("white"), 0.25).alpha(0.5).string(), // focus ring glow
  // input_text: "#e8e8e8", // input text
  // input_placeholder: "#bcbcbc", // placeholder text

  // status_success: "#4caf50", // green
  // status_warning: "#d8a200", // amber
  // status_error: "#d24d4d", // red
  // status_info: "#4da6ff", // blue

  lightest: "#f5f5f5",
  darkest: "#111111",

  overlay_00: "rgba(0, 0, 0, 0.0)",
  overlay_40: "rgba(0, 0, 0, 0.4)",
  overlay_50: "rgba(0, 0, 0, 0.5)",
  overlay_60: "rgba(0, 0, 0, 0.6)",
};

export default colors;

addStyleElement(`
#app {
  color: var(--color-text_primary);
  background: linear-gradient(45deg, var(--color-bg_base), var(--color-bg_darker));
  background-attachment: fixed;

  ${Object.entries(colors)
    .map(([k, v]) => `--color-${k}: ${v};`)
    .join("\n")}}
`);
